module.exports = __webpack_public_path__ + "static/media/frc-summer-2022-image-1.ed96dace.png";